import React from 'react';
import SiteHead from '../../../shared/components/header';
import {Redirect} from "react-router-dom";
import {getNotice, removeNotice} from "../../AuthWrapper/actions";
import {connect} from "react-redux";
import ChatWrapper from '../../../components/Chat';
import {
    joinChatRoom, 
    onConnect, 
    eventOnReconnect, 
    sendMessage, 
    getNumberOfUnreadMessages, 
    readMessage, 
    eventOnRead, 
    eventOnMessage, 
    eventOnLeave, 
    eventOnJoin, 
    leaveChatRoom, 
    getMessagesRequest
} from '../../Chat/actions';
import Notice from "../../../components/Notification/newNotification";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userLoaded: false,
            messages: [],
            connected: false,
            adminIsOnline: false
        }
        this.handleClickSend = this.handleClickSend.bind(this);
        this.handleChangeMessage = this.handleChangeMessage.bind(this);
        this.handleReadMessage = this.handleReadMessage.bind(this);
    }

    toggleNav = (e) => {
        e.preventDefault();
    };

    hideNav = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    onLogoutClick() {
        this.props.onLogout();
    }

    seeNotice (data, userData) {
        this.props.seeNotice(data, [{}]);
    }

    componentDidMount() {
        this.changeUserLoaded(this.props);
        this.props.getNotice();
        this.props.onConnect();
        // this.noticeInterval = setInterval(() => this.props.getNotice(), 7000);
    }

    componentWillUnmount() {
        this.props.leaveChatRoom();
        clearInterval(this.noticeInterval);
    }

    componentWillReceiveProps (nextProps) {
        this.changeUserLoaded(nextProps)
        if (this.props.auth.isUnAuthorized !== nextProps.auth.isUnAuthorized && nextProps.auth.isUnAuthorized) {
            return <Redirect to="/sign-in" />
        }
        if(nextProps.chatData.error && !this.props.chatData.error) {
            Notice.addNotification(nextProps.chatData.error, 'error');
        }
        if(!this.props.chatData.connected && nextProps.chatData.connected) {
            this.props.joinChatRoom();
            this.props.eventOnJoin();
            this.props.eventOnMessage('dentist');
            this.props.eventOnRead('dentist');
            this.props.eventOnLeave();
            this.props.eventOnReconnect();
        }
    }

    changeUserLoaded (propState) {
        if (propState.auth.isCurrentUserLoadingSuccess) {
            this.setState({
                userLoaded: true
            })
        }
    }

    handleClickSend(message) {
        this.props.sendMessage({message, toUserId: 1});
    }

    handleChangeMessage(e) {
        this.setState({[e.target.name] : e.target.value});
    }

    handleReadMessage(messageId) {
        this.props.readMessage(messageId);
    }

    render() {
        if(this.props.auth.userLoading || this.props.auth.userLoading === undefined) { return false; }
        if(!this.props.auth.currentUser && this.props.auth.loggedIn !== true) {
            return <Redirect to="/sign-in" />
        } else if (this.props.auth.currentUser.role === 'super_admin') {
            return <Redirect to="/sm-admin" />
        }
        return (
            <div>
                <ChatWrapper
                    getNumberOfUnreadMessages={this.props.getNumberOfUnreadMessages}
                    getMessages={this.props.getMessages}
                    handleReadMessage={this.handleReadMessage}
                    isSingleChat={true} currentUser={this.props.auth.currentUser}
                    adminIsOnline={this.props.chatData.adminIsOnline}
                    sendMessage={this.handleClickSend}
                    messages={this.props.chatData.messages}
                    numberOfMessages={this.props.chatData.numberOfMessages}
                    noMoreMessages={this.props.chatData.noMoreMessages}
                    loadingMessages={this.props.chatData.loadingMessages}
                    addedMessage={this.props.chatData.addedMessage}
                />
                <div className="app-wrapper">
                    <div className={`content-container full`}>
                        <SiteHead 
                            role={this.props.auth.currentUser.role} 
                            name={this.props.auth.currentUser.first_name +' '+ this.props.auth.currentUser.last_name} 
                            onLogoutClick={this.onLogoutClick.bind(this)} 
                            noticesForUsers={false} 
                            noticesForUsersCount={false} 
                            notices={this.props.auth.notices.notices} 
                            noticeCount={this.props.auth.notices.noticeCount} 
                            onSeeNotice={this.seeNotice.bind(this)}
                            removeNotice={this.props.removeNotice}
                            currentUser={this.props.auth.currentUser}
                        />
                        { this.props.children }
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = state => ({
    chatData: state.chatData
});

const mapDispatchToProps = dispatch => {
    return {
        getNotice: () => dispatch(getNotice()),
        joinChatRoom: (userId) => dispatch(joinChatRoom(userId)),
        sendMessage: (data) => dispatch(sendMessage(data)),
        readMessage: (messageId) => dispatch(readMessage(messageId)),
        eventOnRead: (role) => dispatch(eventOnRead(role)),
        eventOnMessage: (role) => dispatch(eventOnMessage(role)),
        eventOnLeave: () => dispatch(eventOnLeave()),
        eventOnJoin: () => dispatch(eventOnJoin()),
        leaveChatRoom: () => dispatch(leaveChatRoom()),
        getMessages: (partnerId, page) => dispatch(getMessagesRequest(partnerId, page)),
        getNumberOfUnreadMessages: () => dispatch(getNumberOfUnreadMessages()),
        eventOnReconnect: () => dispatch(eventOnReconnect()),
        onConnect: () => dispatch(onConnect()),
        removeNotice: (data) => dispatch(removeNotice(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/index.js